export default "__VITE_ASSET__DUAnlRPa__"